<template>
    <div>
        <h4>Запись на прием к врачу</h4>
        <ol>
            <li>Выбор мед. организации, свободной даты и времени приема врача-психиатра</li>
            <li>Ввод данных о пациенте</li>
            <li>Запись на прием</li>
        </ol>



        <button-component @click="close">Закрыть</button-component>
    </div>
</template>

<script>
import ButtonComponent from "../../../common/components/ButtonComponent";

export default {
  name: "DoctorFindForm",
  components: {
    ButtonComponent
  },
  created() {
  },
  data() {
    return {
      
    };
  },
  methods: {
    close() {
        this.$emit('close');
    }
  }
};
</script>
<style scoped lang="scss">
@import "src/assets/theme/default/colors";

.button-component {
  min-width: 100px;
  display: block;
}

</style>